import React from 'react'

function IOS() {
  return (
    <div>IOS</div>
  )
}

export default IOS